import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import PageContainer from '@deliveroo/consumer-component-library/components/PageContainer';
import P from '@deliveroo/consumer-component-library/components/P';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import BrandLogoCard from '../BrandLogoCard';
import StarRating from '../StarRating';

import styles from './styles.scss';

export default function BrandPageHero({
  headerComponent,
  locationSearchComponent,
  heading,
  logo,
  logoBackgroundColor,
  image,
  rating,
  ratingDescription,
  ratingCount,
  tags,
  themeColor,
  description,
}) {
  const renderBrandMeta = () => (
    <div className={styles.meta}>
      <BrandLogoCard brandName={heading} logoUrl={logo} backgroundColor={logoBackgroundColor} />
      <div className={styles.metaContent}>
        <Heading level={1} size="medium" color="white" spacing="small 0 0 0">
          {heading}
        </Heading>
        <Spacer adjacentVerticalSpacing="small">
          <div className={styles.rating}>
            <div className={styles.stars}>
              <StarRating
                rating={rating}
                description={ratingDescription}
                count={ratingCount}
                isMonochrome
              />
            </div>
            {tags && (
              <div className={styles.tags}>
                <P color="white" size="small">
                  {tags.join(' · ')}
                </P>
              </div>
            )}
          </div>
        </Spacer>
      </div>
    </div>
  );

  return (
    <Fragment>
      <PageContainer fullWidth="always">
        <div className={styles.navHeader}>{headerComponent}</div>
        <div
          className={styles.outerWrapper}
          style={{ color: themeColor, backgroundColor: themeColor }}
        >
          <div className={styles.image} style={{ backgroundImage: `url(${image})` }} />
          <div className={styles.content}>
            <div className={styles.description}>
              {renderBrandMeta()}
              {description && (
                <P color="white" adjacentVerticalSpacing="medium">
                  {description}
                </P>
              )}
            </div>
          </div>
        </div>
      </PageContainer>
      {locationSearchComponent && (
        <PageContainer fullWidth="always">
          <div className={styles.locationSearchWrapper}>
            <PageContainer>
              <div className={styles.locationSearch}>{locationSearchComponent}</div>
            </PageContainer>
          </div>
        </PageContainer>
      )}
    </Fragment>
  );
}

BrandPageHero.propTypes = {
  headerComponent: PropTypes.node.isRequired,
  locationSearchComponent: PropTypes.node,
  heading: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  logoBackgroundColor: PropTypes.string,
  image: PropTypes.string.isRequired,
  rating: PropTypes.string.isRequired,
  ratingDescription: PropTypes.string.isRequired,
  ratingCount: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  themeColor: PropTypes.string,
  description: PropTypes.string.isRequired,
};

BrandPageHero.defaultProps = {
  logoBackgroundColor: undefined,
  locationSearchComponent: undefined,
  themeColor: '#00CCBC',
};
